// import Main from './Main'
import Lista from './components/Lista'

export default [
  // { path: '/comitentes', component: Main, name: 'comitentes.main' },
  {path: '/comitentes/lista', component: Lista, name: 'comitentes.lista'}
]
